import {Dialog, DialogTitle} from "@mui/material";
import {FC} from "react";

interface IProps {
  title: string;
  isOpenAutModal: boolean;
  onCloseModal: () => void;
  children: React.ReactNode;
}

export const CustomModalAuth: FC<IProps> = ({
  title,
  isOpenAutModal,
  onCloseModal,
  children,
}) => {
  return (
    <Dialog
      open={isOpenAutModal}
      onClose={onCloseModal}
      maxWidth="xl"
      PaperProps={{
        sx: {
          backgroundColor: "#161a1d",
          color: "#FAFAFA",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          borderRadius: "12px",
          maxWidth: "1000px",
          overflow: "hidden",
        },
      }}
    >
      <div
        style={{
          maxHeight: "80vh",
          overflowY: "auto",
          borderRadius: "12px",
        }}
      >
        <DialogTitle
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "#161a1d",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "rgba( 255, 255, 255, 0.6 )",
            fontWeight: "200",
          }}
        >
          {title}
        </DialogTitle>
        <div
          style={{
            padding: "32px 40px",
            background: "#23272b",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            minWidth: 320,
            borderRadius: "0 0 12px 12px",
          }}
        >
          {children}
        </div>
      </div>
    </Dialog>
  );
};
